import { HR_DEPT_ID } from "./hrStaffHelpers";

export function getAllEmployeesFromData(data) {
  if (!data) return [];
  return Object.values(data.employeesByBranch || {}).flat();
}

export function findEmployeeByRole(employees, role) {
  if (!employees?.length) return null;

  if (role === "gm") {
    return (
      employees.find((e) => e.roleSlugs?.includes("gm")) ||
      employees.find((e) => e.memberLevel === "gm") ||
      employees.find(
        (e) =>
          e.jobTitle === "المدير العام" || e.jobTitle?.includes("مدير عام"),
      ) ||
      null
    );
  }

  if (role === "hr") {
    return (
      employees.find(
        (e) =>
          (e.departmentId === HR_DEPT_ID &&
            e.memberLevel === "department-manager") ||
          e.jobTitle?.includes("موارد بشرية") ||
          e.jobTitle?.toLowerCase?.().includes("hr"),
      ) || null
    );
  }

  return null;
}

export function findEmployeeIdByRole(employees, role) {
  return findEmployeeByRole(employees, role)?.id ?? null;
}
